(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EventItemDeleteController', EventItemDeleteController);

    EventItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceItem'];

    function EventItemDeleteController($uibModalInstance, entity, ServiceItem) {
        var vm = this;


        vm.serviceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
